import React from 'react'
import './common-title.css'

const Common_title = (props) => {
  return (
    <>
        <section className='Common_title_sec'>
            <h1 className='title'>{props.title}&nbsp;<span>{props.titleblack}</span></h1>
        </section>
    </>
  )
}

export default Common_title